import axios from "axios"
import {PROJECT_URL} from "../globals"
import {generateCRUDUrls, generateFinalUrl} from "./utils"
import {handleError} from "../helpers/errors"


const URL = {
  PROJECTS: generateCRUDUrls("/projects"),

  PROCESSINGS: generateCRUDUrls("/processings"),

  MOVE_PROCESSING: "/processings/{pk}/move-processing/",
  START_PROCESSING: "/processings/{pk}/start-processing/",
  GET_USER_EVALUATION: "/processings/{pk}/get-user_evaluation/",
  START_FLIGHT_ORDER_PROCESSING: "/flight-orders-processings/{pk}/start-processing/",
  CREATE_FLIGHT_ORDER_PROCESSING: "/flight-orders-processings/create-processing/",
  LIST_PROCESSINGS_BY_PROJECT: "/processings/list-processings-by-project/",
  LIST_UPLOADED_IMAGES: "/processings/{pk}/list-uploaded-images/",
  LIST_FLIGHT_ORDER_UPLOADED_IMAGES: "/flight-orders-processings/{pk}/list-uploaded-images/",
  DELETE_UPLOADED_IMAGE: "/processings/{pk}/delete-uploaded-image/",
  DELETE_FLIGHT_ORDER_UPLOADED_IMAGE: "/flight-orders-processings/{pk}/delete-uploaded-image/",
  GET_FLIGHT_ORDER_PROCESSING: "flight-orders-processings/{pk}/get-processing/",
  GET_UPLOADED_FLIGHT_LOG: "/processings/{pk}/get-uploaded-flight-log/",
  GET_FLIGHT_ORDER_UPLOADED_FLIGHT_LOG: "/flight-orders-processings/{pk}/get-uploaded-flight-log/",
  GET_UPLOADED_GCP: "/processings/{pk}/get-uploaded-gcp/",
  GET_FLIGHT_ORDER_UPLOADED_GCP: "/flight-orders-processings/{pk}/get-uploaded-gcp/",
  CALCULATE_PROCESSING_DATA: "/processings/{pk}/calculate-processing-data-optimized/",
  GET_PROCESSING_DATA: "/processings/{pk}/get-processing-data/",
  GET_SCORE_BY_PROCESSING: "/processings/{pk}/get-user-evaluation/",
  SET_PROCESSING_EVALUATION: "/processings/{pk}/evaluate-processing/",
  CALCULATE_FLIGHT_ORDER_PROCESSING_DATA: "/flight-orders-processings/{pk}/calculate-processing-data/",
  CONFIRM_TILLING_PROCESSING: "/processings/{pk}/confirm-tilling-processing/",
  LIST_REPORTS: "/processings/{pk}/list-reports/",
  LIST_REPORTS_SHARED: "/processings/{pk}/list-reports-shared/",
  LIST_FLIGHT_ORDER_REPORTS: "/flight-orders-processings/{pk}/list-reports/",
  LIST_PRODUCTS: "/processings/{pk}/list-products/",
  LIST_PRODUCTS_SHARED: "/processings/{pk}/list-products-shared/",
  LIST_3D_MESH: "/processings/{pk}/list-3d-mesh/",
  LIST_3D_ENTWINE_POINTCLOUD: "/processings/{pk}/list-3d-entwine-pointcloud/",
  LIST_INTERSECTED_PROCESSINGS: "/processings/{pk}/list-intersected-processings/",
  SAVE_COORDS_IMAGES_PROCESSINGS: "/processings/{pk}/coords-images-processings/",
  SAVE_DATA_IMAGES_PROCESSINGS: "/processings/{pk}/data-images-processings/",
  GET_COORDS_IMAGES_PROCESSINGS: "/processings/{pk}/coords-to-images-processings/",

  GENERATE_PROCESSING_SHARE: "/processings/generate-processing-share/",
  GET_PROCESSINGS_SHARE: "/processings/list-processing-share/",  
  
  PROCESSING_SHARE: "/processings/processing-share/",
  REQUEST_REPROCESSING: "/processings/request-reprocessing/",
  DELETE_PROCESSING_SHARE: "/processings/delete-processing-share/",

  PROCESSING_DUPLICATE: "/processings/processing-duplicate/",

  GENERATE_PROJECT_SHARE: "/projects/generate-project-share/",
  PROJECT_SHARE: "/projects/project-share/",
  CREATE_MANUAL_UPLOAD_LINK: "projects/create-manual-upload-link/",
  GET_MANUAL_UPLOAD_PAGE: "projects/get-manual-upload-page/",
  GET_PRESIGNED_URL: "projects/get-presigned-url/",

  FIELDS: generateCRUDUrls("/fields"),
  LIST_FIELDS_BY_PROCESSING: "/fields/list-fields-by-processing/",
  IMPORT_FIELDS: "/fields/import-fields/",
  DOWNLOAD_FIELDS: "/fields/{pk}/download-fields/",

  FIELDS_POST_PROCESSINGS: generateCRUDUrls("/fields-post-processings"),
  LIST_FIELDS_POST_PROCESSINGS_BY_PROCESSINGS: "/fields-post-processings/list-fields-post-processings-by-processings/",
  LIST_FIELD_POST_PROCESSING_ANALYSIS_RESULTS: "/fields-post-processings/{pk}/list-results-by-analysis/",

  PROCESSING_GEOMETRIES: generateCRUDUrls("/processing-geometries"),
  LIST_GEOMETRIES_BY_PROCESSING: "/processing-geometries/list-geometries-by-processing/",
  PROCESSING_REQUEST_UNARCHIVE: `/processings/processing-request-unarchive/{pk}`,
  GET_SHARED_PROCESSING: `/processings/get-shared-processing/{pk}`,
  INTERNAL_EVENT: "/processings/create-internal-event/",

  TILES: "/tiles/",

  PROCESSING_LEVEL_CURVE: "/processings/{pk}/level-curve/",
}


const generateCommonHeader = (authToken) => {
  return {
    Authorization: `Bearer ${authToken}`,
  }
}


const axiosInstance = axios.create({
  baseURL: PROJECT_URL,
})
axiosInstance.interceptors.response.use(null, handleError)


//Projects CRUD
export const listProject = (authToken) => {
  const url = generateFinalUrl(URL.PROJECTS.LIST)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const createProject = (authToken, projectData) => {
  const url = generateFinalUrl(URL.PROJECTS.CREATE)
  return axiosInstance.post(url,
    projectData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const createFlightOrderProcessing = (authToken, flightOrderProcessingData) => {
  const url = generateFinalUrl(URL.CREATE_FLIGHT_ORDER_PROCESSING)

  return axiosInstance.post(url,
    flightOrderProcessingData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    })

}


export const updateProject = (authToken, pk, projectData) => {
  const url = generateFinalUrl(URL.PROJECTS.UPDATE, pk)
  return axiosInstance.put(url,
    projectData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const deleteProject = (authToken, pk) => {
  const url = generateFinalUrl(URL.PROJECTS.DELETE, pk)
  return axiosInstance.delete(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


// Processings CRUD
export const getProcessing = (authToken, pk) => {
  const url = generateFinalUrl(URL.PROCESSINGS.GET, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const getProcessingShared = (pk) => {
  const url = generateFinalUrl(URL.GET_SHARED_PROCESSING, pk)
  return axiosInstance.get(url,
    {},
  )
}


export const listProcessing = (authToken) => {
  const url = generateFinalUrl(URL.PROCESSINGS.LIST)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const createProcessing = (authToken, processingData) => {
  const url = generateFinalUrl(URL.PROCESSINGS.CREATE)
  return axiosInstance.post(url,
    processingData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const updateProcessing = (authToken, pk, processingData) => {
  const url = generateFinalUrl(URL.PROCESSINGS.UPDATE, pk)
  return axiosInstance.put(url,
    processingData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


//export const deleteProcessing = (authToken, pk) => {
//  const url = generateFinalUrl(URL.PROCESSINGS.DELETE, pk)
//  return axiosInstance.delete(url,
//    {
//      headers: generateCommonHeader(authToken),
//      withCredentials: true,
//    },
//  )
//}
export const deleteProcessing = (authToken, pk) => {
  const url = generateFinalUrl(URL.PROCESSINGS.LIST + "delete_processing/", pk)
  return axiosInstance.post(url,
   {
    id_processing: pk,
   },
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const listIntersectedProcessings = (authToken, pk) => {
  const url = generateFinalUrl(URL.LIST_INTERSECTED_PROCESSINGS, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

//Processing Extra
export const listProcessingReports = (authToken, pk) => {
  const url = generateFinalUrl(URL.LIST_REPORTS, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const listProcessingReportsShared = (pk) => {
  const url = generateFinalUrl(URL.LIST_REPORTS_SHARED, pk)
  return axiosInstance.get(url,
    {
      withCredentials: false,
    },
  )
}


export const listFlightOrderProcessingReports = (authToken, pk) => {
  const url = generateFinalUrl(URL.LIST_FLIGHT_ORDER_REPORTS, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true
    })
}


export const listProcessingProducts = (authToken, pk) => {
  const url = generateFinalUrl(URL.LIST_PRODUCTS, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const listProcessingProductsShared = (pk) => {
  const url = generateFinalUrl(URL.LIST_PRODUCTS_SHARED, pk)
  return axiosInstance.get(url,
    {
      withCredentials: false,
    },
  )
}


export const list3dMesh = (authToken, pk) => {
  const url = generateFinalUrl(URL.LIST_3D_MESH, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const list3dEntwinePointCloud = (authToken, pk) => {
  const url = generateFinalUrl(URL.LIST_3D_ENTWINE_POINTCLOUD, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const moveProcessing = (authToken, pk, cdProject) => {
  const url = generateFinalUrl(URL.MOVE_PROCESSING, pk)
  return axiosInstance.post(url,
    {
      cd_project: cdProject,
    },
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const calculateProcessingData = (authToken, pk, zipError) => {
  const url = generateFinalUrl(URL.CALCULATE_PROCESSING_DATA, pk, zipError)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const getProcessingData = (authToken, pk) => {
  const url = generateFinalUrl(URL.GET_PROCESSING_DATA, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const calculateFlightOrderProcessingData = (authToken, pk) => {
  const url = generateFinalUrl(URL.CALCULATE_FLIGHT_ORDER_PROCESSING_DATA, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const confirmTillingProcessing = (authToken, pk) => {
  const url = generateFinalUrl(URL.CONFIRM_TILLING_PROCESSING, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const startProcessing = (authToken, pk) => {
  const url = generateFinalUrl(URL.START_PROCESSING, pk)
  return axiosInstance.post(url,
    {},
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const startFlightOrderProcessing = (authToken, pk) => {
  const url = generateFinalUrl(URL.START_FLIGHT_ORDER_PROCESSING, pk)
  return axiosInstance.post(url,
    {},
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


// Processings Files
export const deleteUploadedImage = (authToken, pk, s3File) => {
  const queryValues = {
    str_img_name: s3File,
  }
  const url = generateFinalUrl(URL.DELETE_UPLOADED_IMAGE, pk, queryValues)
  return axiosInstance.delete(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const deleteFlightOrderUploadedImage = (authToken, pk, s3File) => {
  const queryValues = {
    str_img_name: s3File,
  }
  const url = generateFinalUrl(`${URL.DELETE_FLIGHT_ORDER_UPLOADED_IMAGE}`, pk, queryValues)
  return axiosInstance.delete(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const getFlightOrderProcessing = (authToken, pk) => {
  const url  = generateFinalUrl(URL.GET_FLIGHT_ORDER_PROCESSING, pk)

  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true
    })
}


export const listUploadedImages = (authToken, pk) => {
  const url = generateFinalUrl(URL.LIST_UPLOADED_IMAGES, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const listFlightOrderUploadedImages = (authToken, pk) => {
  const url = generateFinalUrl(URL.LIST_FLIGHT_ORDER_UPLOADED_IMAGES, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const getUploadedFlightLog = (authToken, pk) => {
  const url = generateFinalUrl(URL.GET_UPLOADED_FLIGHT_LOG, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const getFlightOrderUploadedFlightLog = (authToken, pk) => {
  const url = generateFinalUrl(URL.GET_FLIGHT_ORDER_UPLOADED_FLIGHT_LOG, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const getUploadedGcp = (authToken, pk) => {
  const url = generateFinalUrl(URL.GET_UPLOADED_GCP, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const getFlightOrderUploadedGcp = (authToken, pk) => {
  const url = generateFinalUrl(URL.GET_FLIGHT_ORDER_UPLOADED_GCP, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


// Processings Sharing/Cloning
export const generateProcessingShare = (authToken, shareData) => {
  const url = generateFinalUrl(URL.GENERATE_PROCESSING_SHARE)
  return axiosInstance.post(url,
    shareData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const getListProcessingsShare = (authToken, shareData) => {
  const url = generateFinalUrl(URL.GET_PROCESSINGS_SHARE)
  return axiosInstance.post(url,
    shareData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const processingShare = (shareToken) => {
  const url = generateFinalUrl(`${URL.PROCESSING_SHARE}${shareToken}`)
  return axiosInstance.post(url,
    {},
    {
      withCredentials: false,
    },
  )
}

export const createEventInternal = (authToken, data) => {
  const url = generateFinalUrl(`${URL.INTERNAL_EVENT}`)
  return axiosInstance.post(url,
    data,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: false,
    },
  )
}

export const processingDuplicate = (authToken, id, shareData) => {
  const url = generateFinalUrl(`${URL.PROCESSING_DUPLICATE}${id}`)
  return axiosInstance.post(url,
    shareData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const deleteProcessingShare = (authToken, shareToken) => {
  const url = generateFinalUrl(`${URL.DELETE_PROCESSING_SHARE}${shareToken}`)
  return axiosInstance.post(url,
    {},
    {
      headers: generateCommonHeader(authToken),      
      withCredentials: true,
    },
  )
}


// Projects Sharing/Cloning
export const generateProjectShare = (authToken, shareData) => {
  const url = generateFinalUrl(URL.GENERATE_PROJECT_SHARE)
  return axiosInstance.post(url,
    shareData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const projectShare = (authToken, shareToken) => {
  const url = generateFinalUrl(`${URL.PROJECT_SHARE}${shareToken}`)
  return axiosInstance.post(url,
    {},
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


// Manual file uploading
export const createUploadLink = (authToken, subdirectory, expiresIn, requesterId, envUrl) => {
  return axiosInstance.post(URL.CREATE_MANUAL_UPLOAD_LINK,
    {
      subdirectory: subdirectory,
      expiresIn: expiresIn,
      requesterId: requesterId,
      envUrl: envUrl
    },
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const getManualUploadPage = (uuid) => {

  const url = `${URL.GET_MANUAL_UPLOAD_PAGE}?uuid=${uuid}`
  return axiosInstance.get(url,
    {
      withCredentials: false
    },
  )
}

export const getPresignedUrl = (filename) => {

  const url = `${URL.GET_PRESIGNED_URL}?uploadPath=${filename}`
  return axiosInstance.get(url,
    {
      withCredentials: false
    },
  )
}

// Request reprocessing
export const requestReprocess = (authToken, requesterId, processId) => {

  return axiosInstance.post(URL.REQUEST_REPROCESSING,
    {
      cd_user: requesterId,
      cd_process: processId
    },
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


// Fields CRUD
export const createField = (fieldData) => {
  const url = generateFinalUrl(URL.FIELDS.CREATE)
  return axiosInstance.post(url,
    fieldData,
    {
      withCredentials: false,
    },
  )
}

export const updateField = (pk, fieldData) => {
  const url = generateFinalUrl(URL.FIELDS.UPDATE, pk)
  return axiosInstance.put(url,
    fieldData,
    {
      withCredentials: false,
    },
  )
}


export const deleteField = (pk) => {
  const url = generateFinalUrl(URL.FIELDS.DELETE, pk)
  return axiosInstance.delete(url,
    {
      withCredentials: false,
    },
  )
}


export const listFieldsByProcessing = (authToken, cdProcessing) => {
  const queryValues = {
    cd_processing: cdProcessing,
  }
  const url = generateFinalUrl(URL.LIST_FIELDS_BY_PROCESSING, null, queryValues)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const listFieldsByProcessingShared = (cdProcessing) => {
  const queryValues = {
    cd_processing: cdProcessing,
  }
  const url = generateFinalUrl(URL.LIST_FIELDS_BY_PROCESSING, null, queryValues)
  return axiosInstance.get(url,
    {
      withCredentials: false,
    },
  )
}

export const getProcessingScore = (authToken, cdProcessing) => {
  const url = generateFinalUrl(URL.GET_SCORE_BY_PROCESSING, cdProcessing)

  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const updateProcessingEvaluation = (authToken, pk, score, comment) => {
  const url = generateFinalUrl(URL.SET_PROCESSING_EVALUATION, pk)
  return axiosInstance.post(url,
    {
      user_comment: comment,
      user_evaluation: score,
    },
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

// Fields Extra
export const importField = (authToken, cdProcessing, fileObject) => {
  const url = generateFinalUrl(
    `${URL.IMPORT_FIELDS}${cdProcessing}`,
  )
  return axiosInstance.put(url,
    fileObject,
    {
      headers: {
        ...generateCommonHeader(authToken),
        withCredentials: true,
        "Content-Type": fileObject.type,
      },
      withCredentials: true,
    },
  )
}


export const downloadField = (authToken, pk, contentType, extraHeader) => {
  const url = generateFinalUrl(URL.DOWNLOAD_FIELDS, pk)
  return axiosInstance.post(url,
    {
      content_type: contentType,
    },
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
      ...extraHeader,
    },
  )
}


// Fields Post Processings CRUD

export const createFieldsPostProcessing = (authToken, postProcessingData) => {
  const url = generateFinalUrl(URL.FIELDS_POST_PROCESSINGS.CREATE)
  return axiosInstance.post(url,
    postProcessingData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const listFieldsPostProcessings = (authToken, cdProcessing) => {
  const queryValues = {
    cd_processing: cdProcessing,
  }
  const url = generateFinalUrl(URL.LIST_FIELDS_POST_PROCESSINGS_BY_PROCESSINGS, null, queryValues)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

// Fields Post Processings Extras
export const listFieldsPostProcessingAnalysisResults = (authToken, pk, analysisType) => {
  const url = `${generateFinalUrl(URL.LIST_FIELD_POST_PROCESSING_ANALYSIS_RESULTS, pk)}${analysisType}`
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

// ProcessingGeometries CRUD
export const listProcessingGeometriesByProcessing = (authToken, cdProcessing) => {
  const queryValues = {
    cd_processing: cdProcessing,
  }
  const url = generateFinalUrl(URL.LIST_GEOMETRIES_BY_PROCESSING, null, queryValues)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const listProcessingGeometriesByProcessingShared = (cdProcessing) => {
  const queryValues = {
    cd_processing: cdProcessing,
  }
  const url = generateFinalUrl(URL.LIST_GEOMETRIES_BY_PROCESSING, null, queryValues)
  return axiosInstance.get(url,
    {
      withCredentials: false,
    },
  )
}


export const createProcessingGeometries = (processingGeometryData) => {
  const url = generateFinalUrl(URL.PROCESSING_GEOMETRIES.CREATE)
  return axiosInstance.post(url,
    processingGeometryData,
    {
      withCredentials: false,
    },
  )
}


export const updateProcessingGeometries = (pk, processingGeometryData) => {
  const url = generateFinalUrl(URL.PROCESSING_GEOMETRIES.UPDATE, pk)
  return axiosInstance.put(url,
    processingGeometryData,
    {
      withCredentials: false,
    },
  )
}


export const deleteProcessingGeometries = (authToken, pk) => {
  const url = generateFinalUrl(URL.PROCESSING_GEOMETRIES.DELETE, pk)
  return axiosInstance.delete(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const getProcessingRequestUnarchive = (authToken, pk) => {
  const url = generateFinalUrl(URL.PROCESSING_REQUEST_UNARCHIVE, pk)
  return axiosInstance.get(
    url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}


export const getLevelCurve = (authToken, pk) => {
  const url = generateFinalUrl(URL.PROCESSING_LEVEL_CURVE, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const postCoordsImages = (authToken, pk, postData) => {
  const url = generateFinalUrl(URL.SAVE_COORDS_IMAGES_PROCESSINGS, pk)
  return axiosInstance.post(url,
    {
      json_coords: postData,
    },
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const postCoordsToImages = (authToken, pk, postData) => {
  const url = generateFinalUrl(URL.GET_COORDS_IMAGES_PROCESSINGS, pk)
  return axiosInstance.post(url,
    {
      json_coords: postData,
    },
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}

export const postDataImages = (authToken, pk, postData) => {
  const url = generateFinalUrl(URL.SAVE_DATA_IMAGES_PROCESSINGS, pk)
  return axiosInstance.post(url,
    {
      json_data: postData,
    },
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    },
  )
}